import {Injectable} from "@angular/core";
import {Account} from "src/app/auth/auth.model";
import {AccountsApiService} from "../../api/accounts-api.service";
import {Observable} from "rxjs/index";
import {AppResponse} from "../../api/app-response.model";

@Injectable()
export class AccountSuperAdminService {

  constructor(
    private accountApi: AccountsApiService
  ) {
  }

  saveUpdate(account: Account): Observable<AppResponse<void>> {
    let edit = false;

    if (account.id != null) {
      edit = true;
    }

    if (edit) {
      return this.accountApi.update(account);
    } else {
      return this.accountApi.save(account);
    }
  }
}
